import { render, staticRenderFns } from "./expandable-group-table.vue?vue&type=template&id=200ace48&scoped=true&"
import script from "./expandable-group-table.vue?vue&type=script&lang=js&"
export * from "./expandable-group-table.vue?vue&type=script&lang=js&"
import style0 from "./expandable-group-table.vue?vue&type=style&index=0&id=200ace48&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200ace48",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VExpandTransition,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('200ace48')) {
      api.createRecord('200ace48', component.options)
    } else {
      api.reload('200ace48', component.options)
    }
    module.hot.accept("./expandable-group-table.vue?vue&type=template&id=200ace48&scoped=true&", function () {
      api.rerender('200ace48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/crm/components/expandable-group-table/expandable-group-table.vue"
export default component.exports